import * as Actions from '../../actions';

const initialState = { data: null };

const viewWashesReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_WASH_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default viewWashesReducer;
